import {colorUtils, idGenerator} from "_src/utils";
import {objectType} from "_src/constants";
import projectTree from "_src/reformer/project_tree";

export default class Wrapper {
  constructor(params) {
    this.id = "id" in params ? params.id : idGenerator.getNext();
    this.loaded = false;
    this.type = objectType.ANONYM;
    this._loadPromise = null;
  }

  _selfPropertyGetter(name) {
    const property = projectTree._getProperty(this.getID());
    if (!property) return null;
    return property.getValue(name);
  }

  _selfPropertySetter(name, value) {
    const property = projectTree._getProperty(this.getID());
    if (!property) return;
    projectTree.setPropertyValue(this.getID(), name, value);
  }

  getID() {
    return this.id;
  }

  getProperty(name) {
    return this._selfPropertyGetter(name);
  }

  getUUID() {
    return this._selfPropertyGetter("uuid");
  }

  getName() {
    return this._selfPropertyGetter("name");
  }

  setName(name) {
    this._selfPropertySetter("name", name);
  }

  getVisibility() {
    return this._selfPropertyGetter("visible");
  }

  setVisibility(visibility) {
    this._selfPropertySetter("visible", visibility);
  }

  getColor() {
    const colorObj = colorUtils.hexToRgb(this._selfPropertyGetter("color"));
    return [colorObj.r, colorObj.g, colorObj.b];
  }

  setColor(r, g, b) {
    this._selfPropertySetter("color", colorUtils.rgbToHex(r, g, b));
  }

  isLoadingNeeded() {
    return this.getVisibility() && !this.loaded;
  }

  async loadData() {
    if (this.loaded) return;
    if (!this._loadPromise) this._loadPromise = this._loadData();

    await this._loadPromise;
    this.loaded = true;
  }

  unloadData() {
    this._loadPromise = null;
    this._unloadData();
    this.loaded = false;
  }

  async _loadData() {}
  _unloadData() {}
}
